import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {PackagesComponent} from "./packages.component";
import {MsPackageDetailsComponent} from "./ms-package-details/ms-package-details.component";
import {Ms2PackageDetailsComponent} from "./ms2-package-details/ms2-package-details.component";
import {ZsPackageDetailsComponent} from "./zs-package-details/zs-package-details.component";
import {VsPackageDetailsComponent} from "./vs-package-details/vs-package-details.component";
import {RsPackageDetailsComponent} from "./rs-package-details/rs-package-details.component";
import {LsPackageDetailsComponent} from "./ls-package-details/ls-package-details.component";
import {GsPackageDetailsComponent} from "./gs-package-details/gs-package-details.component";
import {CmsPageComponent} from "../../shared/components/cms-page/cms-page.component";
import {CmsService} from "../../core/services/cms.service";
import {EsPackageDetailsComponent} from "./es-package-details/es-package-details.component";


const routes: Routes = [{
  path: "",
  component: PackagesComponent,
},
  {
    path: "schoonmaak-per-uur",
    children: [
      {
        path: "",
        component: MsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  },
  {
    path: "eind-schoonmaak",
    children: [
      {
        path: "",
        component: EsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  },
  {
    path: "oplever-schoonmaak",
    children: [
      {
        path: "",
        component: EsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  },
  {
    path: "maat-schoonmaak",
    children: [
      {
        path: "",
        component: Ms2PackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  }, {
    path: "zwangerschap-schoonmaak",
    children: [
      {
        path: "",
        component: ZsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  }, {
    path: "verhuis-schoonmaak",
    children: [
      {
        path: "",
        component: VsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  }, {
    path: "verbouw-schoonmaak",
    children: [
      {
        path: "",
        component: RsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  }, {
    path: "voorjaar-schoonmaak",
    children: [
      {
        path: "",
        component: LsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  }, {
    path: "grote-schoonmaak",
    children: [
      {
        path: "",
        component: GsPackageDetailsComponent,
      },
      {
        path: "**",
        component: CmsPageComponent,
        resolve: {
          cmsContent: CmsService
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PackagesRoutingModule {
}
